import { useState, useEffect } from 'react'
import { supabase } from '../utils/supabase'

interface Todo {
  id: number
  first_name: string
}

export default function SupabaseTestPage() {
  const [todos, setTodos] = useState<Todo[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function getTodos() {
      try {
        const { data, error } = await supabase.from('user_requests').select('*')

        if (error) {
          setError(error.message)
        } else if (data) {
          setTodos(data as Todo[])
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error')
      } finally {
        setLoading(false)
      }
    }

    getTodos()
  }, [])

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading...</div>
  }

  if (error) {
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h2>Error</h2>
        <p>{error}</p>
      </div>
    )
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Supabase Test Page</h1>
      {todos.length === 0 ? (
        <p>No todos found (table may be empty)</p>
      ) : (
        <ul>
          {todos.map((todo) => (
            <li key={todo.id}>{todo.first_name}</li>
          ))}
        </ul>
      )}
    </div>
  )
}